<script setup lang="ts">
import SVGWrapper from "./utils/SVGWrapper.vue";

import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
}

withDefaults(defineProps<IconProps>(), { size: "md" });
</script>

<template>
  <SVGWrapper :size="size" viewBox="0 0 24 24">
    <mask
      id="mask0_17114_57697"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="21"
      height="21"
    >
      <circle cx="12.1348" cy="12.1289" r="10" fill="white" />
    </mask>
    <g mask="url(#mask0_17114_57697)">
      <rect x="7.17578" y="0.623047" width="10.1826" height="21.8535" fill="white" />
      <rect x="16.166" y="0.275391" width="7.15234" height="21.8535" fill="#DF3636" />
      <rect x="0.917969" y="0.275391" width="7.15234" height="21.8535" fill="#279B2C" />
    </g>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
